module.exports = __webpack_public_path__ + "static/red-berries2-ed039ffcddc2745d72d2c08a261f738f.svg";